import React, { useMemo } from 'react';
import LazyLoad from 'react-lazyload';
import { string, number } from 'prop-types';
import { AppStore, GooglePlay } from '@alltrails/shared-components';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import starRating from './star_rating.png';
import { toATLocalString } from '../../../utils/number_util';
import styles from './styles/styles.module.scss';
import { DESKTOP_BREAKPOINT } from '../../../utils/constants/breakpoints';

const {
  strings: {
    HOME_PAGE: {
      EDITORS_CHOICE_BLOCK: { INSPIRATION_FOR, YOUR_TRAIL, EDITORS_CHOICE }
    }
  }
} = StringConstantsMixin;

const EditorsChoiceBlock = ({ languageRegionCode, windowWidth }) => {
  const shortRegionCode = languageRegionCode.split('-')[0];

  const isDesktop = useMemo(() => {
    return windowWidth && windowWidth >= DESKTOP_BREAKPOINT;
  }, [windowWidth]);

  const [appStoreWidth, googlePlayWidth, backgroundImageUrl] = useMemo(() => {
    return [
      isDesktop ? 144 : 118,
      isDesktop ? 162 : 133,
      `https://cdn-assets.alltrails.com/assets/images/homepage/editors_choice/background-${isDesktop ? 'desktop' : 'mobile'}.jpg`
    ];
  }, [isDesktop]);

  const containerStyle = useMemo(() => {
    return {
      backgroundImage: `url(${backgroundImageUrl})`
    };
  }, [backgroundImageUrl]);

  return (
    <div style={containerStyle} className={styles.container}>
      <div className={styles.innerContainer}>
        <div className={styles.badgeStarContainer}>
          <LazyLoad>
            <img
              className={styles.badgeImage}
              src={`https://cdn-assets.alltrails.com/assets/images/editors_choice_${shortRegionCode}.png`}
              alt={EDITORS_CHOICE}
            />
          </LazyLoad>
          <span className={styles.rating}>{toATLocalString(4.9, languageRegionCode, 1)}</span>
          <LazyLoad>
            <img alt="" src={starRating} className={styles.starsImage} />
          </LazyLoad>
        </div>
        <h3 className={styles.titleTop}>{INSPIRATION_FOR}</h3>
        <h3 className={styles.titleBottom}>{YOUR_TRAIL}</h3>
        <div className={styles.stores}>
          <>
            <LazyLoad>
              <AppStore width={appStoreWidth} languageRegionCode={languageRegionCode} className={`${styles.appStore}`} />
              <GooglePlay width={googlePlayWidth} languageRegionCode={languageRegionCode} />
            </LazyLoad>
          </>
        </div>
      </div>
    </div>
  );
};

EditorsChoiceBlock.propTypes = {
  languageRegionCode: string,
  windowWidth: number
};

EditorsChoiceBlock.defaultProps = {
  languageRegionCode: 'en-US',
  windowWidth: null
};

export default EditorsChoiceBlock;
